import React, { FC, useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { Check } from "lucide-react";
import { ConfigOfferInterface, OfferChoise } from "./logic";
import OfferDetails from "./OfferDetails";
import { CustomButton } from "../Ui/CustomButton";
import { OffersInfo } from "../../graphql/onboarding/offer/types/OffersInfo";
import PromotionButton from "./price";

interface OfferListProps {
  offerSelected: OffersInfo | null;
  offers: (OffersInfo | null)[];
  config: ConfigOfferInterface;
  setChoice: (data: OfferChoise) => void;
  choice: OfferChoise;
  create?: boolean;
  pack?: {
    packageSelected: number;
    setPackageSelected: (month: number) => void;
  };
}

const useStyles = makeStyles((theme) => ({
  offer: {
    margin: theme.spacing(0.5, 0.5),
    textTransform: "uppercase",
    minWidth: 110,
  },
  package: {
    margin: theme.spacing(0.5, 0.5),
    minWidth: 110,
    textTransform: "lowercase",
  },
  list: {
    "@media (max-width: 400px)": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
    },
  },
}));

const OfferList: FC<OfferListProps> = ({
  offerSelected,
  offers,
  config,
  setChoice,
  choice,
  create,
  pack,
}) => {
  const { setPackageSelected, packageSelected } = pack || {};
  const classes = useStyles();
  const [offerDisplay, setOfferDisplay] = useState<OffersInfo | null>(
    offerSelected,
  );

  const handleDisplayOffer = (offer: OffersInfo) => {
    setOfferDisplay(offer);
    setChoice({ ...choice, offerId: offer.id });
  };

  return (
    <Box marginTop={2}>
      {offerDisplay && <OfferDetails offer={offerDisplay} config={config} />}
      <Box className={classes.list}>
        {offers?.map((o) => {
          if (o?.name) {
            return (
              <CustomButton
                className={classes.offer}
                label={o.name}
                variant={offerDisplay?.id === o?.id ? "outline4" : "outline"}
                onClick={() => handleDisplayOffer(o)}
                {...(offerDisplay?.id === o?.id && {
                  endIcon: <Check style={{ width: 14 }} />,
                })}
              />
            );
          }
        })}
      </Box>
      {create && pack && (
        <>
          <Box className={classes.list}>
            <CustomButton
              className={classes.package}
              label={"6 mois"}
              variant={packageSelected == 6 ? "outline4" : "outline"}
              onClick={() => {
                setPackageSelected && setPackageSelected(6);
              }}
              {...(packageSelected == 6 && {
                endIcon: <Check style={{ width: 14 }} />,
              })}
            />
            <CustomButton
              className={classes.package}
              label={"12 mois"}
              variant={packageSelected == 12 ? "outline4" : "outline"}
              onClick={() => {
                setPackageSelected && setPackageSelected(12);
              }}
              {...(packageSelected == 12 && {
                endIcon: <Check style={{ width: 14 }} />,
              })}
            />
          </Box>
          {!!offerDisplay?.oneYearPackagePrice &&
            !!offerDisplay?.sixMonthsPackagePrice &&
            !!offerDisplay?.price &&
            packageSelected && (
              <Box>
                <PromotionButton
                  newPrice={
                    packageSelected == 12
                      ? offerDisplay?.oneYearPackagePrice
                      : offerDisplay?.sixMonthsPackagePrice
                  }
                  oldPrice={offerDisplay?.price * packageSelected}
                />
              </Box>
            )}
        </>
      )}
    </Box>
  );
};

export default OfferList;
